var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFranchiseLogo = function SvgFranchiseLogo(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 29.5625,
    y1: 39.014439,
    x2: 29.5625,
    y2: 137.304382,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(40.392157%,93.725491%,92.54902%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(49.803922%,92.941177%,76.862746%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 21.5,
    x2: 86,
    y2: 157.232193,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(8.627451%,81.568629%,80.000001%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 104.8125,
    y1: 19.798809,
    x2: 104.8125,
    y2: 155.119812,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(8.627451%,81.568629%,80.000001%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 104.772186,
    y1: 19.820311,
    x2: 104.772186,
    y2: 154.877945,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(8.627451%,81.568629%,80.000001%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 104.772186,
    y1: 19.820311,
    x2: 104.772186,
    y2: 154.877945,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(8.627451%,81.568629%,80.000001%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 104.815193,
    y1: 19.809561,
    x2: 104.815193,
    y2: 154.668304,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(8.627451%,81.568629%,80.000001%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 104.8125,
    y1: 19.817631,
    x2: 104.8125,
    y2: 155.090256,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(8.627451%,81.568629%,80.000001%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientUnits: "userSpaceOnUse",
    x1: 104.8125,
    y1: 19.820311,
    x2: 104.8125,
    y2: 154.877945,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(8.627451%,81.568629%,80.000001%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface9282750"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 10.15625 39.0625 L 7.03125 39.0625 C 6.167969 39.0625 5.46875 38.363281 5.46875 37.5 L 5.46875 24.21875 C 5.46875 23.355469 6.167969 22.65625 7.03125 22.65625 L 10.15625 22.65625 C 11.019531 22.65625 11.71875 23.355469 11.71875 24.21875 L 11.71875 37.5 C 11.71875 38.363281 11.019531 39.0625 10.15625 39.0625 Z M 10.15625 39.0625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 44.082031 29.542969 C 43.351562 29 42.375 28.84375 41.398438 29.113281 L 29.457031 32.414062 C 29.601562 32.054688 29.6875 31.660156 29.6875 31.242188 C 29.6875 29.523438 28.285156 28.125 26.5625 28.125 L 19.238281 28.125 C 18.714844 27.34375 17.390625 25 15.625 25 L 12.5 25 L 12.5 24.21875 C 12.5 22.925781 11.449219 21.875 10.15625 21.875 L 7.03125 21.875 C 5.738281 21.875 4.6875 22.925781 4.6875 24.21875 L 4.6875 37.5 C 4.6875 38.792969 5.738281 39.84375 7.03125 39.84375 L 10.15625 39.84375 C 11.449219 39.84375 12.5 38.792969 12.5 37.5 L 12.5 36.914062 L 21.984375 43.320312 C 23.175781 44.125 24.558594 44.53125 25.949219 44.53125 C 27.230469 44.53125 28.515625 44.1875 29.652344 43.492188 L 43.851562 34.820312 C 44.753906 34.269531 45.3125 33.269531 45.3125 32.214844 L 45.3125 31.96875 C 45.3125 31.007812 44.863281 30.125 44.082031 29.542969 Z M 10.9375 37.5 C 10.9375 37.929688 10.585938 38.28125 10.15625 38.28125 L 9.375 38.28125 L 9.375 35.15625 L 7.8125 35.15625 L 7.8125 38.28125 L 7.03125 38.28125 C 6.601562 38.28125 6.25 37.929688 6.25 37.5 L 6.25 24.21875 C 6.25 23.789062 6.601562 23.4375 7.03125 23.4375 L 10.15625 23.4375 C 10.585938 23.4375 10.9375 23.789062 10.9375 24.21875 Z M 43.75 32.214844 C 43.75 32.730469 43.476562 33.21875 43.035156 33.484375 L 28.839844 42.15625 C 26.992188 43.285156 24.644531 43.234375 22.859375 42.027344 L 12.5 35.027344 L 12.5 26.5625 L 15.625 26.5625 C 16.453125 26.5625 17.554688 28.152344 18.039062 29.226562 L 18.246094 29.6875 L 26.5625 29.6875 C 27.425781 29.6875 28.125 30.386719 28.125 31.242188 C 28.125 32.109375 27.425781 32.8125 26.5625 32.8125 L 18.75 32.8125 L 18.75 34.375 L 28.125 34.375 L 41.816406 30.621094 C 42.316406 30.480469 42.816406 30.546875 43.152344 30.796875 C 43.53125 31.082031 43.75 31.507812 43.75 31.96875 Z M 43.75 32.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 30.472656 25.78125 C 27.871094 25.78125 25.269531 24.789062 23.289062 22.808594 C 21.367188 20.890625 20.3125 18.339844 20.3125 15.625 C 20.3125 12.910156 21.367188 10.359375 23.289062 8.441406 C 27.246094 4.480469 33.695312 4.480469 37.652344 8.441406 C 41.613281 12.402344 41.613281 18.847656 37.652344 22.808594 C 35.675781 24.789062 33.074219 25.78125 30.472656 25.78125 Z M 30.46875 7.03125 C 28.269531 7.03125 26.066406 7.871094 24.390625 9.546875 C 22.769531 11.167969 21.875 13.328125 21.875 15.625 C 21.875 17.921875 22.769531 20.082031 24.390625 21.703125 C 27.742188 25.058594 33.199219 25.058594 36.546875 21.703125 C 39.898438 18.351562 39.898438 12.898438 36.546875 9.546875 C 34.875 7.871094 32.671875 7.03125 30.46875 7.03125 Z M 30.46875 7.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 22.65625 10.15625 L 38.257812 10.15625 L 38.257812 11.71875 L 22.65625 11.71875 Z M 22.65625 10.15625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 22.65625 19.53125 L 38.257812 19.53125 L 38.257812 21.09375 L 22.65625 21.09375 Z M 22.65625 19.53125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear5)"
    },
    d: "M 21.109375 14.84375 L 39.832031 14.84375 L 39.832031 16.40625 L 21.109375 16.40625 Z M 21.109375 14.84375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear6)"
    },
    d: "M 29.6875 6.25 L 31.25 6.25 L 31.25 25 L 29.6875 25 Z M 29.6875 6.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear7)"
    },
    d: "M 30.46875 25.78125 C 27.402344 25.78125 25 21.320312 25 15.625 C 25 9.929688 27.402344 5.46875 30.46875 5.46875 C 33.535156 5.46875 35.9375 9.929688 35.9375 15.625 C 35.9375 21.320312 33.535156 25.78125 30.46875 25.78125 Z M 30.46875 7.03125 C 28.621094 7.03125 26.5625 10.5625 26.5625 15.625 C 26.5625 20.6875 28.621094 24.21875 30.46875 24.21875 C 32.316406 24.21875 34.375 20.6875 34.375 15.625 C 34.375 10.5625 32.316406 7.03125 30.46875 7.03125 Z M 30.46875 7.03125 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFranchiseLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/franchiseLogo.0d66a593.svg";
export { ForwardRef as ReactComponent };